export enum ResetPosition {
  Left = 'Left',
  Right = 'Right',
}

export enum BADGES_LAYOUT {
  SINGLE_ROW = 'single-row',
  MULTIPLE_ROWS = 'multiple-rows',
  MULTIPLE_ROWS_RESET_OWN_ROW = 'multiple-rows-reset-own-row',
}
